import { Columns } from '@/components/table/types';
import { MpApp, MpAppStatus, revokeMPA } from '@api/plc';
import WhiteList from './white-list.vue';
import styles from '../../game/member/style.module.styl';
import ApplyPlc from './apply.vue';
import { defineComponent, inject } from '@vue/composition-api';
import { ConfTableKey } from '@/components/table/table';
import { SpecificPropsType } from '@/components/form/types';
import {
    handleErrorMessageToast,
    handleSuccessMessageToast,
} from '@/common/util';

const RevokePlc = defineComponent({
    props: ['row'] as unknown as SpecificPropsType<{
        row: MpApp;
    }>,
    setup: (props, { slots, root }) => {
        const table = inject(ConfTableKey);
        const onClick = (e: MouseEvent) => {
            e.stopPropagation();
            root.$confirm(
                `是否确认解除对【小程序：${props.row.mpAppName}，ID：${props.row.mpAppId}】的挂载绑定`,
                '确认解除？',
                {
                    type: 'warning',
                    confirmButtonText: '解除',
                    cancelButtonText: '返回',
                },
            ).then(
                async () => {
                    const res = await revokeMPA(
                        root.$route.params.appId,
                        props.row.mpAppId,
                    );
                    if (res.data.result === 1) {
                        handleSuccessMessageToast('解除成功');
                        table?.fetch();
                    } else {
                        handleErrorMessageToast(
                            res.data.error_msg || '解除失败',
                        );
                    }
                },
                () => {},
            );
        };

        return () => {
            return <span onClick={onClick}>{slots.default()}</span>;
        };
    },
});

export const detailColumns: (scopeGroupId: number) => Columns<MpApp>[] = (
    scopeGroupId,
) => [
    {
        label: '小程序ID',
        width: '165px',
        prop: 'mpAppId',
    },
    {
        label: '小程序名称',
        align: 'center',
        prop: 'mpAppName',
    },
    {
        label: '白名单',
        width: '65px',
        align: 'center',
        render: ({ row }) =>
            row.status !== MpAppStatus.已封禁 ? (
                <WhiteList mpAppId={row.mpAppId}>
                    <a class={styles.method}>查看</a>
                </WhiteList>
            ) : (
                '-'
            ),
    },
    {
        label: '状态',
        width: '70px',
        align: 'center',
        render: ({ row }) => (
            <div
                style={{
                    color:
                        row.status === MpAppStatus.已驳回
                            ? '#FA5B57'
                            : 'inherit',
                }}
            >
                {MpAppStatus[row.status]}
            </div>
        ),
    },
    {
        label: '操作',
        width: '80px',
        align: 'center',
        render: ({ row }) => {
            switch (row.status) {
                case MpAppStatus.已封禁:
                case MpAppStatus.已获取:
                    return (
                        <RevokePlc row={row}>
                            <a class={styles.method}>解除挂载</a>
                        </RevokePlc>
                    );
                case MpAppStatus.已驳回:
                    return (
                        <ApplyPlc row={row} scopeGroupId={scopeGroupId}>
                            <a class={styles.method}>重新提交</a>
                        </ApplyPlc>
                    );
                default:
                    return '-';
            }
        },
    },
];
